function getCookie(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for(var i = 0; i <ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
  }

const OfferPopup = {
	getElements() {
		this.$popup = $('.js-modal-offer-popup');
		this.$overlay = $('.js-modal-offer-overlay');
		this.$mobileBanner = $('.js-modal-offer-mobile-banner');
		this.$mobileTrigger = $('.js-modal-offer-mobile-trigger');
		this.$form = $('.js-modal-offer-form');
		this.$page1 = $('.js-modal-offer-page-1');
		this.$page2 = $('.js-modal-offer-page-2');
		this.$loader = $('.js-modal-offer-loader');
		this.$close = $('.js-modal-offer-close');
		this.$box = $('.js-modal-offer-box');
		this.$code = $('.js-modal-offer-code');
		this.$nameField = $('.js-modal-offer-name-field');
		this.$emailField = $('.js-modal-offer-email-field');
		this.$hpField = $('.js-modal-offer-hp-field');
		this.$nonceField = $('#_wpnonce');
	},
	hidePopup(e) {
		e.preventDefault();
		this.rejectOffer();
		this.$popup.hide();
	},
	showOverlay() {
		this.$overlay.css('display', 'flex');
	},
	hideMobileBanner() {
		this.$mobileBanner.hide();
	},
	rejectOffer() {
		const self = this;

		const data = {
			action: 'popup_offer_reject',
			_ajax_nonce: self.$nonceField.val(),
		};

		$.ajax({
            type: 'POST',
            url: ajaxurl,
            data: data,
		});
	},
	submitForm(e) {
		const self = this;

		e.preventDefault();

		self.$page1.hide();
		self.$loader.show();

		const data = {
			name: self.$nameField.val(),
			email: self.$emailField.val(),
			hp: self.$hpField.val(),
			action: 'popup_offer_signup',
			_ajax_nonce: self.$nonceField.val(),
		};

		$.ajax({
            type: 'POST',
            url: ajaxurl,
            data: data,
		}).done(result => {
			self.$loader.hide();
			const response = JSON.parse(result);
			if (response.status == 'success') {
				self.$code.text(response.code);
				self.$page2.show();
				window.dataLayer = window.dataLayer || [];
				dataLayer.push({
					'event': 'confirmation shown',
				});
			} else {
				self.$page1.show();
				alert('An error occurred - please check your details and try again!');
			}
		});
	},
	addEventListeners() {
		const self = this;

		self.$close.on('click', self.hidePopup.bind(self));
		self.$form.on('submit', self.submitForm.bind(self));
		self.$mobileTrigger.on('click', function() {
			self.hideMobileBanner();
			self.showOverlay();
			window.dataLayer = window.dataLayer || [];
			dataLayer.push({
				'event': 'signup form shown',
			});
		});
	},
	init() {
		this.getElements();

		var is_front_page = $('body').hasClass('home') ? true : false;

		if (this.$popup.length > 0) {
			if (is_front_page == false || parseInt(getCookie('popup_offer_complete')) === 1 || parseInt(getCookie('popup_offer_rejected')) === 1 || (parseInt(getCookie('popup_offer_rejection_count')) >= 2)) {
			} else {
				this.addEventListeners();
				this.$popup.show();
				window.dataLayer = window.dataLayer || [];
				if (this.$mobileBanner.is(':visible')) {
					dataLayer.push({
						'event': 'mobile banner shown',
					});
				} else {
					dataLayer.push({
						'event': 'signup form shown',
					});
				}
			}
		}
	},
};

export default OfferPopup;
